import React from 'react';
import cx from 'clsx';
import { Media, MontanaMediaRatios } from '@montana/shared/media';
import { IPromotionalMenuCard } from '../../shell/header/drawer-menu/drawer-menu.types';

export interface IPromotionalMenuCardProps {
  card: IPromotionalMenuCard;
  className?: string;
}

export const PromotionalMenuCard: React.FC<IPromotionalMenuCardProps> = ({ card, className }) => {
  if (!card) return null as any;

  const { image, link } = card;
  const alt = image?.altText || image?.title || '';

  return (
    <div className={cx('promotional-menu-card', className)}>
      <div className={cx('promotional-menu-card__image-wrapper', 'drawer-menu__promoted-image-wrapper')}>
        <Media
          image={image?.url}
          alt={alt}
          mediaRatio={MontanaMediaRatios.Portrait}
          keepRatio
        />
      </div>
      {link?.url && (
        <a
          href={link.url}
          className={cx('promotional-menu-card__link', 'drawer-menu__promoted-link')}
          title={link.title || link.name || undefined}
          target={link.target || undefined}
        >
          {link.name || link.title}
        </a>
      )}
    </div>
  );
};

PromotionalMenuCard.displayName = 'PromotionalMenuCard';
